export const DiariesLabelValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.DiariesLable.trim()) {
      errors.DiariesLable = 'This field is required';
    } 
    return errors;
  };
  
 